import { TFormAddressData } from "./CreditCardForm.interface";

const composeAddress = (address: TFormAddressData): string => {
  const { street, postalCode, city, country } = address;
  return [street, [postalCode, city].filter((v) => !!v).join(" "), country]
    .filter((v) => !!v)
    .join(", ");
};

export default composeAddress;
